import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { Main } from '../styles/commonStyles';
import { Header } from './Header';

export const LoadingView: React.FC = () => {
	return (
		<Main>
			<Header />

			<Box
				display="flex"
				justifyContent="center"
				alignItems="center"
				minHeight="60vh"
				px={{ xs: 2, sm: 0 }}
			>
				<Box textAlign="center">
					<CircularProgress
						size={60}
						sx={{ mb: 3, color: 'primary.main' }}
					/>
					<Typography
						variant="h6"
						gutterBottom
						fontFamily="Oxanium"
						sx={{
							fontSize: { xs: '18px', sm: '20px' },
						}}
					>
						Loading your dashboard
					</Typography>
					<Typography
						color="textSecondary"
						fontFamily="Oxanium"
						sx={{
							fontSize: { xs: '14px', sm: '15px', md: '16px' },
						}}
					>
						Checking for active positions...
					</Typography>
				</Box>
			</Box>
		</Main>
	);
};
